import { render, staticRenderFns } from "./_show_icons.html?vue&type=template&id=237a4909&scoped=true&"
import script from "./_show_icons.js?vue&type=script&lang=js&"
export * from "./_show_icons.js?vue&type=script&lang=js&"
import style0 from "./_show_icons.css?vue&type=style&index=0&id=237a4909&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a4909",
  null
  
)

export default component.exports